export default {
  url(url) {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$',
      'i',
    );

    // return !pattern.test(url);
    if (!pattern.test(url)) return true;
    try {
      const parsed = new URL(url);
      const hostname = parsed.hostname.toLowerCase();
      if (
        hostname === 'localhost'
        || hostname === '127.0.0.1'
        || hostname === '::1'
      ) {
        return true;
      }
      return false;
    } catch (_) {
      return true;
    }
  },

  /**
 * Validates a file against allowed mime types and extension.
 *
 * @param {File} file - The file selected from the input element.
 * @param {Object} config - Validation configuration.
 * @param {string[]} config.mimeList - Allowed MIME types.
 * @param {string} config.extension - Required file extension.
 *
 * @returns {{ valid: boolean, message?: string }}
 */

  fileTypeIsValid(file, config) {
    const { mimeList, extension } = config;

    if (!mimeList.includes(file.type) && !file.name.endsWith(extension)) {
      return {
        valid: false,
        message: `You must select a ${extension} file`,
      };
    }

    return { valid: true };
  },
};
